<section *ngIf="!isVerifyShowing" [ngClass]="onLogin ? 'login-height' : 'settings-height'">
    <div class="form-wrap">
        <form [formGroup]="newPasswordForm" (ngSubmit)="newPasswordSubmit()">
            <h2>Create a new password</h2>
            <p>Password requires at least:</p>
            <div class="requirements">
                <div class="icons">
                    <mat-icon *ngIf="passwordRequirements?.hasMinLength; else noMin">check</mat-icon>
                    <ng-template #noMin>
                        <mat-icon></mat-icon>
                    </ng-template>
                    <mat-icon *ngIf="passwordRequirements?.hasLower; else noLower">check</mat-icon>
                    <ng-template #noLower>
                        <mat-icon></mat-icon>
                    </ng-template>
                    <mat-icon *ngIf="passwordRequirements?.hasUpper; else noUpper">check</mat-icon>
                    <ng-template #noUpper>
                        <mat-icon></mat-icon>
                    </ng-template>
                    <mat-icon *ngIf="passwordRequirements?.hasNumber; else noNum">check</mat-icon>
                    <ng-template #noNum>
                        <mat-icon></mat-icon>
                    </ng-template>
                    <mat-icon *ngIf="passwordRequirements?.hasSpecialChar; else noSpecialChar">check</mat-icon>
                    <ng-template #noSpecialChar>
                        <mat-icon></mat-icon>
                    </ng-template>
                    <mat-icon *ngIf="passwordRequirements?.bothMatch; else noMatch">check</mat-icon>
                    <ng-template #noMatch>
                        <mat-icon></mat-icon>
                    </ng-template>
                </div>
                <ul>
                    <li [ngClass]="passwordRequirements?.hasMinLength ? 'requirement-met' : 'requirement-not-met'">A minimum of 8 characters</li>
                    <li [ngClass]="passwordRequirements?.hasLower ? 'requirement-met' : 'requirement-not-met'">A lowercase letter</li>
                    <li [ngClass]="passwordRequirements?.hasUpper ? 'requirement-met' : 'requirement-not-met'">An uppercase letter</li>
                    <li [ngClass]="passwordRequirements?.hasNumber ? 'requirement-met' : 'requirement-not-met'">A number</li>
                    <li [ngClass]="passwordRequirements?.hasSpecialChar ? 'requirement-met' : 'requirement-not-met'">
                        Any special character (the "_" character is not a special character)
                    </li>
                    <li [ngClass]="passwordRequirements?.bothMatch ? 'requirement-met' : 'requirement-not-met'">Both passwords must match</li>
                </ul>
            </div>
            <mat-form-field style="width: 100%" appearance="fill">
                <mat-label>New Password</mat-label>
                <input
                    [type]="viewPassword ? 'text' : 'password'"
                    autocomplete="off"
                    matInput
                    formControlName="password"
                    maxlength="30"
                    [host]="this"
                    appValidatePassword="password"
                />
                <mat-icon *ngIf="!viewPassword" matSuffix (click)="passwordVisible(1)" class="my-icon">visibility</mat-icon>
                <mat-icon *ngIf="viewPassword" matSuffix (click)="passwordVisible(1)" class="my-icon">visibility_off</mat-icon>
                <mat-error>Invalid password</mat-error>
            </mat-form-field>
            <mat-form-field style="width: 100%" appearance="fill">
                <mat-label>Confirm New Password</mat-label>
                <input
                    [type]="viewPassword2 ? 'text' : 'password'"
                    autocomplete="off"
                    matInput
                    formControlName="password2"
                    [host]="this"
                    appValidatePassword="password2"
                />
                <mat-icon *ngIf="!viewPassword2" matSuffix (click)="passwordVisible(2)" class="my-icon">visibility</mat-icon>
                <mat-icon *ngIf="viewPassword2" matSuffix (click)="passwordVisible(2)" class="my-icon">visibility_off</mat-icon>
                <mat-error *ngIf="newPasswordForm.get('password2')?.errors?.noMatch">Both passwords must match</mat-error>
                <mat-error *ngIf="newPasswordForm.get('password2')?.errors?.required">Invalid password</mat-error>
            </mat-form-field>
            <div>
                <button style="width: 100%" class="mt-2 auth-form-submit" mat-flat-button type="submit" color="primary">Submit</button>
            </div>
            <hr />
        </form>
    </div>
</section>

<ng-container *ngIf="isVerifyShowing">
    <enter-verification (verify$)="verifyChange($event)" [phone]="phone"></enter-verification>
</ng-container>

<ddj-spinner *ngIf="isLoading"></ddj-spinner>
